/*
  Franchise (round 52): the opening over the store's front (snippets/vr-franchise-opening.liquid).
  - The curtain: maroon velvet hanging in folds, lit from above, gold braid down its leading edges and along its hem,
    and the house's two doves worked in gold across its middle, one on each half. Once the photograph behind it is
    there it is drawn apart as a curtain on a track is: the leading edge travels to the side gathering the cloth
    into a bunch that grows as it goes, while the cloth it has not reached yet hangs as it was; the middle and the
    hem follow the top a moment behind on springs, so the leading edge curves as it travels. The gathered cloth is
    drawn on past the arch's sides, into the wings, until none of it is left in view, and the curtain is then taken
    away (round 61, the owner: the curtains go out of view and disappear). WebGL: the folds are waves along the
    cloth, shaded as velvet (dark in the valleys, light where the pile is seen side on), and the gold takes a
    highlight from the same light.
  - The crackers: as the curtain begins to open (round 61: with it, no longer after it) two anars at the foot of the
    steps spray gold; then shells burst in gold around the arch, two rising on their rockets: golden willows whose
    trails hang and fall, and one that crackles. A 2D canvas laid over the opening, its sparks added as light.
  - The store's lights come up as the last of them fall.
  Without WebGL the curtain drawn in CSS is slid apart; visitors who ask for reduced motion see the store at once
  (assets/vr-franchise.css).
*/
(function () {
  var cur = document.querySelector('[data-vrfr-curtain]');
  if (!cur) return;
  var arch = cur.parentNode;
  var head = arch.closest('.vrfr-open');
  if (!head) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var photo = arch.querySelector('.vrfr-open__photo');
  head.classList.add('is-js');

  /* ---------------- the curtain's movement (in arch widths, each half measured from its own side) ---------------- */
  var C = {
    out: -0.02,   /* the outer edge of each half, just behind the arch's side */
    shut: 0.512,  /* the leading edge when shut: the halves overlap a little at the middle */
    gather: 0.104, /* where the leading edge would rest with each half gathered at its side */
    open: -0.13,  /* the leading edge when drawn: past the arch's side, the gathered cloth and its shadow out of view */
    dur: 3.8,     /* seconds for the top to travel */
    top: 0, mid: 0, bot: 0, vm: 0, vb: 0, settled: false, gone: false
  };
  C.top = C.mid = C.bot = C.shut;
  C.w1 = C.shut - C.out;             /* the width each half covers when shut */
  C.ws = C.gather - C.out;           /* the width it is gathered into */
  C.w0 = 1.45 * C.w1;                /* the cloth's own width: when shut it still hangs in soft folds */
  var pull = function (x) {          /* the hand on the cord: a slow start, a steady draw, a slow finish */
    x = Math.max(0, Math.min(1, x));
    return x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2;
  };
  var stepCurtain = function (t, dt) {
    var n = Math.max(1, Math.ceil(dt / (1 / 240))), h = dt / n;
    for (var i = 0; i < n; i++) {
      var tt = t - dt + (i + 1) * h;
      C.top = C.shut + (C.open - C.shut) * pull(tt / C.dur);
      /* the middle of the drop follows closely, the hem further behind and swinging */
      var am = 52 * (C.top - C.mid) - 2 * 0.64 * Math.sqrt(52) * C.vm;
      C.vm += am * h; C.mid += C.vm * h;
      var ab = 17 * (C.top - C.bot) - 2 * 0.42 * Math.sqrt(17) * C.vb;
      C.vb += ab * h; C.bot += C.vb * h;
    }
    /* gone: the leading edge from top to hem, and the shadow it casts (0.07 of the arch wide), past the arch's side */
    if (Math.max(C.top, C.mid, C.bot) + 0.075 < 0) { C.gone = C.settled = true; return; }
    if (t > C.dur && Math.abs(C.bot - C.top) < 0.0004 && Math.abs(C.vb) < 0.002 && Math.abs(C.mid - C.top) < 0.0004) {
      C.mid = C.bot = C.top = C.open; C.settled = true;
    }
  };
  var openAtOnce = function () { C.top = C.mid = C.bot = C.open; C.vm = C.vb = 0; C.settled = C.gone = true; };

  /* ---------------- the velvet, in WebGL ---------------- */
  var VS = [
    'attribute vec2 aP;',
    'uniform vec3 uE;',          /* the leading edge at the top, the middle (a control point) and the hem */
    'uniform float uOut, uW1, uWs, uW0, uMir;',
    'varying vec2 vP;',
    'varying float vC;',
    'varying vec2 vXY;',
    /* where the cloth at u hangs: as it was when shut, or stacked behind the leading edge, whichever is nearer the side,
       the change from one to the other softened as cloth is between two hooks */
    'float place(float u, float e) {',
    '  float a = uOut + u * uW1;',
    '  float b = e - (1.0 - u) * uWs;',
    '  float k = 0.07 * clamp((1.0 - u) * 5.0, 0.0, 1.0) + 0.0001;',
    '  float h = max(k - abs(a - b), 0.0) / k;',
    '  return min(a, b) - h * h * k * 0.25;',
    '}',
    'void main() {',
    '  float u = aP.x, v = aP.y;',
    '  float e = mix(mix(uE.x, uE.y, v), mix(uE.y, uE.z, v), v);',
    '  float uc = min(u, 1.0);',
    '  float x = place(uc, e);',
    '  float dx = (uc < 0.995 ? place(uc + 0.004, e) - x : x - place(uc - 0.004, e)) / 0.004;',
    '  x += max(u - 1.0, 0.0);',
    '  float X = mix(x, 1.0 - x, uMir);',
    '  vP = aP;',
    '  vC = uW0 / max(dx, 0.02);',
    '  vXY = vec2(X, v);',
    '  gl_Position = vec4(X * 2.0 - 1.0, 1.0 - 2.0 * v, 0.0, 1.0);',
    '}'
  ].join('\n');
  var FS = [
    'precision highp float;',
    'varying vec2 vP;',
    'varying float vC;',
    'varying vec2 vXY;',
    'uniform float uW0, uAsp, uShade, uMir, uPh;',
    'uniform vec4 uMk;',
    'uniform sampler2D uTex;',
    'float hash(vec2 p) { p = fract(p * vec2(233.34, 851.73)); p += dot(p, p + 23.45); return fract(p.x * p.y); }',
    'float noise(vec2 p) { vec2 i = floor(p); vec2 f = fract(p); vec2 w = f * f * (3.0 - 2.0 * f);',
    '  return mix(mix(hash(i), hash(i + vec2(1.0, 0.0)), w.x), mix(hash(i + vec2(0.0, 1.0)), hash(i + vec2(1.0, 1.0)), w.x), w.y); }',
    'void main() {',
    '  float u = vP.x, v = vP.y;',
    /* past the leading edge: the curtain's shadow on the store front */
    '  if (u > 1.0) {',
    '    float k = clamp((u - 1.0) / 0.07, 0.0, 1.0);',
    '    gl_FragColor = vec4(0.0, 0.0, 0.0, uShade * (1.0 - k) * (1.0 - k));',
    '    return;',
    '  }',
    '  float s = u * uW0;',
    '  float d = uW0 - s;',
    /* the folds: three waves along the cloth, their phase wandering a little down the drop */
    '  float k1 = 43.98 / uW0, k2 = 79.17 / uW0, k3 = 19.79 / uW0;',
    '  float a1 = v * 2.3 + 1.1 + uPh, a2 = v * 5.3 + 0.4, a3 = v * 1.9 + 2.0, a4 = v * 1.4 + 0.3;',
    '  float w1 = 0.21 * k1 * s + 3.0 * uPh + 0.8 * v;',
    '  float q1 = k1 * s + uPh + 0.55 * sin(a1) + 0.22 * sin(a2) + 1.1 * sin(w1);',
    '  float q2 = k2 * s + 1.7 * uPh + 0.9 * sin(a3);',
    '  float q3 = k3 * s + 0.6 * uPh + 0.45 * sin(a4);',
    '  float h = 0.62 * sin(q1) + 0.2 * sin(q2) + 0.32 * sin(q3);',
    '  float hs = 0.62 * k1 * (1.0 + 0.231 * cos(w1)) * cos(q1) + 0.2 * k2 * cos(q2) + 0.32 * k3 * cos(q3);',
    '  float hv = 0.62 * cos(q1) * (1.265 * cos(a1) + 1.166 * cos(a2)) + 0.342 * cos(q2) * cos(a3) + 0.2 * cos(q3) * cos(a4);',
    '  float sx = 0.0135 * hs * vC;',
    '  sx = sx / sqrt(1.0 + sx * sx / 14.0);',
    '  float sy = 0.0135 * hv / uAsp;',
    '  float dir = 1.0 - 2.0 * uMir;',
    '  vec3 N = normalize(vec3(-sx * dir, -sy, 1.0));',
    '  vec3 L = normalize(vec3(-0.32, -0.52, 0.80));',
    '  float diff = clamp((dot(N, L) + 0.28) / 1.28, 0.0, 1.0);',
    '  float rim = pow(clamp(1.0 - N.z, 0.0, 1.0), 1.6);',
    '  float deep = clamp((vC - 1.0) / 3.5, 0.0, 1.0);',
    '  float ao = 1.0 - (0.32 + 0.42 * deep) * smoothstep(0.25, -1.0, h / 1.14);',
    /* a warm pool of light from above the middle of the arch */
    '  vec2 pc = (vXY - vec2(0.5, -0.08)) * vec2(1.0, uAsp * 0.6);',
    '  float lamp = 0.30 + 1.05 * exp(-dot(pc, pc) / 0.5);',
    '  float fine = smoothstep(4.0, 1.6, vC);',
    '  float mott = noise(vec2(s * 7.0 + 5.0 * uMir, v * 4.5));',
    '  float grain = noise(vec2(s * 300.0, v * 300.0 * uAsp / uW0));',
    '  vec3 col = vec3(0.100, 0.0050, 0.0090) * (0.10 + 1.12 * diff) + vec3(0.30, 0.032, 0.036) * rim * (0.45 + 0.6 * mott) * (0.35 + 0.65 * diff);',
    '  float side = mix(0.42, 1.0, smoothstep(0.0, 0.07, min(vXY.x, 1.0 - vXY.x)));',
    '  col *= lamp * ao * side * (1.0 + 0.12 * fine * (grain - 0.5)) * vec3(1.0, 0.95, 0.9);',
    /* gold: braid down the leading edge and along the hem, and the doves */
    '  vec3 H = normalize(L + vec3(0.0, 0.0, 1.0));',
    '  float trim = max(smoothstep(0.0135, 0.0118, d), smoothstep(0.972, 0.975, v));',
    '  float braid = 0.86 + 0.14 * fine * sin(d * 560.0 + v * uAsp * 380.0);',
    '  float sp = pow(max(dot(N, H), 0.0), 20.0);',
    '  vec3 gold = (vec3(0.50, 0.30, 0.075) * (0.16 + 1.0 * diff) + vec3(1.0, 0.82, 0.5) * sp * 1.25) * lamp * side;',
    '  col = mix(col, gold * braid, trim);',
    '  vec2 ml = vec2(uMk.x + uMk.y * d, (v - uMk.z) / uMk.w);',
    '  if (ml.x > 0.0 && ml.x < 1.0 && ml.y > 0.0 && ml.y < 1.0) {',
    '    float m = texture2D(uTex, ml).a * mix(1.0, smoothstep(0.3, 0.75, N.z), deep);',
    '    float mb = texture2D(uTex, ml, 3.0).a;',
    '    float e = 2.0 / 1024.0;',
    '    float gx = texture2D(uTex, ml + vec2(e, 0.0), 1.0).a - texture2D(uTex, ml - vec2(e, 0.0), 1.0).a;',
    '    float gy = texture2D(uTex, ml + vec2(0.0, 2.0 * e), 1.0).a - texture2D(uTex, ml - vec2(0.0, 2.0 * e), 1.0).a;',
    '    vec3 Nm = normalize(N + vec3(-gx, -gy, 0.0) * 1.6);',
    '    float dm = clamp((dot(Nm, L) + 0.28) / 1.28, 0.0, 1.0);',
    '    float sm = pow(max(dot(Nm, H), 0.0), 16.0);',
    '    float stitch = 0.88 + 0.12 * fine * sin((ml.x * 2.0 + ml.y) * 300.0);',
    '    vec3 thread = (vec3(0.50, 0.30, 0.075) * (0.18 + 0.95 * dm) + vec3(1.0, 0.84, 0.52) * sm * 1.15) * lamp * side * stitch;',
    '    col *= 1.0 - 0.38 * mb * (1.0 - m) * (1.0 - trim);',
    '    col = mix(col, thread, m * (1.0 - trim));',
    '  }',
    '  gl_FragColor = vec4(pow(col, vec3(0.4545)), 1.0);',
    '}'
  ].join('\n');

  var velvet = function () {
    var cv = document.createElement('canvas');
    cv.className = 'vrfr-curtain__gl';
    var gl = null;
    try { gl = cv.getContext('webgl', { alpha: true, premultipliedAlpha: true, antialias: true }); } catch (e) { gl = null; }
    if (!gl) return null;
    var shader = function (type, src) {
      var sh = gl.createShader(type);
      gl.shaderSource(sh, src);
      gl.compileShader(sh);
      return gl.getShaderParameter(sh, gl.COMPILE_STATUS) ? sh : null;
    };
    var vs = shader(gl.VERTEX_SHADER, VS), fs = shader(gl.FRAGMENT_SHADER, FS);
    if (!vs || !fs) return null;
    var pg = gl.createProgram();
    gl.attachShader(pg, vs); gl.attachShader(pg, fs); gl.linkProgram(pg);
    if (!gl.getProgramParameter(pg, gl.LINK_STATUS)) return null;
    gl.useProgram(pg);

    /* the cloth as a grid of u (across, 0 at the half's side, 1 at its leading edge) by v (down), and past the edge a
       strip for its shadow */
    var NU = 96, NV = 56, NS = 5, pts = [], idx = [];
    var grid = function (us) {
      var base = pts.length / 2, cols = us.length;
      for (var j = 0; j <= NV; j++) for (var i = 0; i < cols; i++) pts.push(us[i], j / NV);
      var first = idx.length;
      for (j = 0; j < NV; j++) for (i = 0; i < cols - 1; i++) {
        var a = base + j * cols + i, b = a + 1, c = a + cols, d2 = c + 1;
        idx.push(a, b, c, b, d2, c);
      }
      return { first: first, count: idx.length - first };
    };
    var cloth = [], shade = [];
    for (var i = 0; i <= NU; i++) cloth.push(i / NU);
    for (i = 0; i <= NS; i++) shade.push(1 + 0.07 * i / NS + (i === 0 ? 0.00001 : 0));
    var gCloth = grid(cloth), gShade = grid(shade);
    var vb = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, vb);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array(pts), gl.STATIC_DRAW);
    var ib = gl.createBuffer();
    gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, ib);
    gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, new Uint16Array(idx), gl.STATIC_DRAW);
    var aP = gl.getAttribLocation(pg, 'aP');
    gl.enableVertexAttribArray(aP);
    gl.vertexAttribPointer(aP, 2, gl.FLOAT, false, 0, 0);
    var U = {};
    ['uE', 'uOut', 'uW1', 'uWs', 'uW0', 'uMir', 'uAsp', 'uShade', 'uPh', 'uMk', 'uTex'].forEach(function (n) { U[n] = gl.getUniformLocation(pg, n); });

    /* the doves, white on nothing, as the embroidery's pattern */
    var tex = gl.createTexture();
    var mk = document.createElement('canvas');
    mk.width = 1024; mk.height = 512;
    var m2 = mk.getContext('2d');
    var dove = cur.querySelector('[id$="-dove"]');
    if (dove && window.Path2D) {
      var path = new Path2D(dove.getAttribute('d'));
      m2.fillStyle = '#fff';
      m2.save(); m2.scale(1024 / 213.6, 512 / 107); m2.fill(path);
      m2.translate(213.6, 0); m2.scale(-1, 1); m2.fill(path); m2.restore();
    }
    gl.bindTexture(gl.TEXTURE_2D, tex);
    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, mk);
    gl.generateMipmap(gl.TEXTURE_2D);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR_MIPMAP_LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    gl.uniform1i(U.uTex, 0);

    gl.enable(gl.BLEND);
    gl.blendFunc(gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
    gl.clearColor(0, 0, 0, 0);
    cur.appendChild(cv);

    var asp = 1.35;
    var size = function () {
      var r = arch.getBoundingClientRect();
      if (!r.width) return;
      var k = Math.min(window.devicePixelRatio || 1, 2);
      cv.width = Math.round(r.width * k);
      cv.height = Math.round(r.height * k);
      asp = r.height / r.width;
    };
    size();
    /* the doves sit across the middle, 44% of the arch wide, their centre 37% down: in the cloth's own measure from
       each leading edge, as the curtain hangs shut */
    var LW = 0.44, c0 = C.w0 / C.w1;
    var draw = function () {
      gl.viewport(0, 0, cv.width, cv.height);
      gl.clear(gl.COLOR_BUFFER_BIT);
      var lh = LW * (107 / 213.6) / asp;
      var drawn = Math.max(0, Math.min(1, (C.shut - C.top) / (C.shut - C.open)));
      gl.uniform3f(U.uE, C.top, C.mid, C.bot);
      gl.uniform1f(U.uOut, C.out);
      gl.uniform1f(U.uW1, C.w1);
      gl.uniform1f(U.uWs, C.ws);
      gl.uniform1f(U.uW0, C.w0);
      gl.uniform1f(U.uAsp, asp);
      gl.uniform1f(U.uShade, 0.5 * Math.min(1, drawn * 4));
      for (var pass = 0; pass < 2; pass++) {
        for (var side = 0; side < 2; side++) {
          gl.uniform1f(U.uMir, side);
          gl.uniform1f(U.uPh, side ? 2.1 : 0.4);
          /* left half: x of the doves' box = shut edge minus distance / c0, mapped to 0..1 across both doves */
          var x0 = 0.5 - LW / 2;
          if (side === 0) gl.uniform4f(U.uMk, (C.shut - x0) / LW, -1 / (c0 * LW), 0.37 - lh / 2, lh);
          else gl.uniform4f(U.uMk, (1 - C.shut - x0) / LW, 1 / (c0 * LW), 0.37 - lh / 2, lh);
          var g = pass === 0 ? gShade : gCloth;
          gl.drawElements(gl.TRIANGLES, g.count, gl.UNSIGNED_SHORT, g.first * 2);
        }
      }
    };
    var lost = false;
    cv.addEventListener('webglcontextlost', function (e) { e.preventDefault(); lost = true; cur.classList.add('is-gl-lost'); }, false);
    return {
      draw: function () { if (!lost) draw(); }, size: size, canvas: cv,
      /* once the curtain has gone from view: its canvas taken away and its drawing let go */
      release: function () { var x = gl.getExtension('WEBGL_lose_context'); if (x) x.loseContext(); if (cv.parentNode) cv.parentNode.removeChild(cv); }
    };
  };

  /* ---------------- the crackers ---------------- */
  var crackers = function () {
    var cv = document.createElement('canvas');
    cv.className = 'vrfr-crackers';
    cv.setAttribute('aria-hidden', 'true');
    var ctx = cv.getContext('2d');
    if (!ctx) return null;
    head.appendChild(cv);
    var W = 0, H = 0, dpr = 1, A = { x: 0, y: 0, w: 1, h: 1 }, phone = false;
    var size = function () {
      var hr = head.getBoundingClientRect(), ar = arch.getBoundingClientRect();
      W = document.documentElement.clientWidth; H = hr.height;
      dpr = Math.min(window.devicePixelRatio || 1, 1.5);
      cv.style.left = -hr.left + 'px';
      cv.style.width = W + 'px';
      cv.style.height = H + 'px';
      cv.width = Math.round(W * dpr);
      cv.height = Math.round(H * dpr);
      A = { x: ar.left, y: ar.top - hr.top, w: ar.width, h: ar.height };
      phone = W < 750;
    };
    size();

    /* colours of a spark as it cools, from white gold to deep amber, and a soft round light for each */
    var PAL = [], SPR = [];
    for (var i = 0; i < 12; i++) {
      var t = i / 11;
      var r = Math.round(150 + 105 * Math.min(1, t * 1.6));
      var g = Math.round(64 + 182 * Math.pow(t, 0.9));
      var b = Math.round(18 + 204 * Math.pow(t, 2.2));
      PAL.push('rgb(' + r + ',' + g + ',' + b + ')');
      var sp = document.createElement('canvas');
      sp.width = sp.height = 32;
      var s2 = sp.getContext('2d');
      var gr = s2.createRadialGradient(16, 16, 0, 16, 16, 16);
      gr.addColorStop(0, 'rgba(255,250,235,1)');
      gr.addColorStop(0.18, 'rgba(' + r + ',' + g + ',' + b + ',0.85)');
      gr.addColorStop(0.45, 'rgba(' + r + ',' + g + ',' + b + ',0.22)');
      gr.addColorStop(1, 'rgba(' + r + ',' + g + ',' + b + ',0)');
      s2.fillStyle = gr;
      s2.fillRect(0, 0, 32, 32);
      SPR.push(sp);
    }

    /* every spark, star, rocket and crackle in flat arrays */
    var MAX = 12000, n = 0;
    var X = new Float32Array(MAX), Y = new Float32Array(MAX), VX = new Float32Array(MAX), VY = new Float32Array(MAX);
    var AGE = new Float32Array(MAX), LIFE = new Float32Array(MAX), HEAT = new Float32Array(MAX), SZ = new Float32Array(MAX);
    var DRAG = new Float32Array(MAX), GRAV = new Float32Array(MAX), EMIT = new Float32Array(MAX), ACC = new Float32Array(MAX);
    var KIND = new Uint8Array(MAX), TYPE = new Uint8Array(MAX), FLAG = new Uint8Array(MAX), RR = new Float32Array(MAX), PX = new Float32Array(MAX), PY = new Float32Array(MAX);
    /* kinds: 0 spark, 1 star, 2 rocket, 3 crackle, 4 fountain spark; flags: 1 inside the arch, 2 crackles at its end,
       4 forks once, 8 forked */
    var add = function (k, x, y, vx, vy, life, heat, sz, drag, grav) {
      if (n >= MAX) return -1;
      var j = n++;
      KIND[j] = k; X[j] = PX[j] = x; Y[j] = PY[j] = y; VX[j] = vx; VY[j] = vy; AGE[j] = 0; LIFE[j] = life; HEAT[j] = heat;
      SZ[j] = sz; DRAG[j] = drag; GRAV[j] = grav; EMIT[j] = 0; ACC[j] = 0; FLAG[j] = 0; RR[j] = 0; TYPE[j] = 0;
      return j;
    };
    var kill = function (j) {
      var l = --n;
      if (j === l) return;
      KIND[j] = KIND[l]; X[j] = X[l]; Y[j] = Y[l]; VX[j] = VX[l]; VY[j] = VY[l]; AGE[j] = AGE[l]; LIFE[j] = LIFE[l];
      HEAT[j] = HEAT[l]; SZ[j] = SZ[l]; DRAG[j] = DRAG[l]; GRAV[j] = GRAV[l]; EMIT[j] = EMIT[l]; ACC[j] = ACC[l];
      FLAG[j] = FLAG[l]; RR[j] = RR[l]; PX[j] = PX[l]; PY[j] = PY[l]; TYPE[j] = TYPE[l];
    };
    var rnd = Math.random;
    var gauss = function () { return (rnd() + rnd() + rnd() - 1.5) / 0.5; };
    var q = 1;       /* fewer sparks if the machine is slow */
    var flashes = [];

    var SHELLS = {
      willow: { stars: 104, speed: 2.25, drag: 2.0, grav: 0.55, life: [2.5, 3.2], emit: 34, spark: [0.9, 1.7], sheat: 0.62, sdrag: 3.2, sgrav: 0.16 },
      crackle: { stars: 78, speed: 3.0, drag: 2.6, grav: 0.5, life: [1.25, 1.6], emit: 16, spark: [0.3, 0.55], sheat: 0.7, sdrag: 2.6, sgrav: 0.3, crackle: true }
    };
    var burst = function (x, y, R, type, more) {
      var S = SHELLS[type], N = Math.round(S.stars * (phone ? 0.6 : 1) * (more || 1) * (0.5 + 0.5 * q));
      for (var k = 0; k < N; k++) {
        var z = 2 * rnd() - 1, a = 2 * Math.PI * rnd(), rr = Math.sqrt(1 - z * z), sp = R * S.speed * (0.9 + 0.15 * rnd());
        var j = add(1, x, y, Math.cos(a) * rr * sp, Math.sin(a) * rr * sp, S.life[0] + (S.life[1] - S.life[0]) * rnd(), 1, phone ? 2 : 2.3, S.drag, S.grav * R);
        if (j < 0) break;
        EMIT[j] = S.emit * (phone ? 0.65 : 1) * q;
        RR[j] = R;
        if (S.crackle) FLAG[j] |= 2;
        ACC[j] = rnd();
        TYPE[j] = type === 'willow' ? 0 : 1;
      }
      flashes.push({ x: x, y: y, r: R * 1.1, age: 0 });
    };
    var shellOf = function (j) { return TYPE[j] === 0 ? SHELLS.willow : SHELLS.crackle; };

    var rockets = [], fountains = [], plan = [];
    var arm = function () {
      var a = A, bottom = H;
      var L = phone ? { x: a.x + 0.22 * a.w, y: a.y + 0.16 * a.h } : { x: a.x - 0.10 * a.w, y: a.y + 0.12 * a.h };
      var Rt = phone ? { x: a.x + 0.8 * a.w, y: a.y + 0.27 * a.h } : { x: a.x + 1.1 * a.w, y: a.y + 0.22 * a.h };
      var F = { x: a.x + 0.5 * a.w, y: a.y + (phone ? 0.12 : 0.18) * a.h };
      var low = phone ? a.y + a.h : bottom;
      /* seconds after the curtain begins to move: the anars as its parting first shows (it starts slowly), the rockets
         and the last shell after them */
      plan = [
        { at: 0.6, f: function () { fountains.push({ x: a.x + 0.16 * a.w, y: a.y + 0.975 * a.h, h: a.h * 0.36, age: 0, dur: 4.2, acc: 0 }); fountains.push({ x: a.x + 0.84 * a.w, y: a.y + 0.975 * a.h, h: a.h * 0.36, age: 0, dur: 4.2, acc: 0, late: 0.12 }); } },
        { at: 1.2, f: function () { rockets.push({ x0: L.x + 0.03 * a.w, y0: low, x1: L.x, y1: L.y, T: 1.05, age: 0, type: 'willow', R: a.w * (phone ? 0.3 : 0.36) }); } },
        { at: 2.0, f: function () { rockets.push({ x0: Rt.x - 0.03 * a.w, y0: low, x1: Rt.x, y1: Rt.y, T: 1.0, age: 0, type: 'crackle', R: a.w * (phone ? 0.26 : 0.3) }); } },
        { at: 3.7, f: function () { burst(F.x, F.y, a.w * (phone ? 0.4 : 0.46), 'willow', 1.25); } }
      ];
    };
    arm();

    var spark = function (x, y, vx, vy, life, heat, sz, drag, grav, kind) {
      return add(kind || 0, x, y, vx, vy, life, heat, sz, drag, grav);
    };
    var step = function (t, dt) {
      while (plan.length && t >= plan[0].at) plan.shift().f();
      var R0 = A.w;
      /* rockets: up on a slowing climb with a little sway, trailing sparks, and burst at the top */
      for (var i = rockets.length - 1; i >= 0; i--) {
        var r = rockets[i];
        r.age += dt;
        var p = Math.min(1, r.age / r.T), e = 1 - (1 - p) * (1 - p);
        var nx = r.x0 + (r.x1 - r.x0) * e + Math.sin(r.age * 9) * 0.006 * R0, ny = r.y0 + (r.y1 - r.y0) * e;
        var vx = (nx - (r.px || nx)) / Math.max(dt, 1e-3), vy = (ny - (r.py || ny)) / Math.max(dt, 1e-3);
        var m = Math.round((phone ? 70 : 110) * dt * q + rnd());
        for (var k = 0; k < m; k++) {
          var f = rnd();
          spark(nx - vx * dt * f, ny - vy * dt * f, -vx * 0.06 + gauss() * 0.03 * R0, -vy * 0.06 + gauss() * 0.03 * R0, 0.25 + 0.3 * rnd(), 0.92, phone ? 1.4 : 1.6, 2.5, 0.3 * R0);
        }
        r.px = nx; r.py = ny; r.x = nx; r.y = ny;
        if (p >= 1) { burst(r.x1, r.y1, r.R, r.type); rockets.splice(i, 1); }
      }
      /* fountains: a spray up from the foot of the steps that rises, flickers and dies down */
      for (i = fountains.length - 1; i >= 0; i--) {
        var fo = fountains[i];
        fo.age += dt;
        var ft = fo.age - (fo.late || 0);
        if (ft < 0) continue;
        var env = Math.min(1, ft / 0.3) * Math.max(0, Math.min(1, (fo.dur - ft) / 0.8));
        fo.env = env;
        if (ft > fo.dur) { fountains.splice(i, 1); continue; }
        var ta = 0.72, gF = 2 * fo.h / (ta * ta), V = gF * ta;
        fo.acc += (phone ? 330 : 600) * q * env * (0.75 + 0.5 * rnd()) * dt;
        while (fo.acc >= 1) {
          fo.acc -= 1;
          var an = gauss() * 0.15, sv = V * (rnd() < 0.35 ? 0.4 + 0.3 * rnd() : 0.78 + 0.3 * rnd());
          var j = spark(fo.x + gauss() * 0.004 * R0, fo.y, Math.sin(an) * sv, -Math.cos(an) * sv, 0.9 + 0.5 * rnd(), 1, (phone ? 1.5 : 1.8) + 0.6 * rnd(), 0.7, gF, 4);
          if (j >= 0) { FLAG[j] |= 1; if (rnd() < 0.2) { FLAG[j] |= 4; RR[j] = 0.3 + 0.3 * rnd(); } }
        }
      }
      /* every particle */
      for (i = n - 1; i >= 0; i--) {
        AGE[i] += dt;
        var kd = KIND[i];
        if (kd === 3 && AGE[i] < 0) continue;
        if (AGE[i] >= LIFE[i]) {
          if (kd === 1 && (FLAG[i] & 2)) {
            var c = 5 + Math.floor(rnd() * 4), RRi = RR[i];
            for (k = 0; k < c; k++) {
              var cj = add(3, X[i] + gauss() * 0.035 * RRi, Y[i] + gauss() * 0.035 * RRi, 0, 0, 0.05 + 0.06 * rnd(), 1, phone ? 1.8 : 2.1, 0, 0);
              if (cj >= 0) AGE[cj] = -0.38 * rnd();
            }
          }
          kill(i);
          continue;
        }
        PX[i] = X[i]; PY[i] = Y[i];
        var dg = Math.exp(-DRAG[i] * dt);
        VX[i] *= dg; VY[i] = VY[i] * dg + GRAV[i] * dt;
        X[i] += VX[i] * dt; Y[i] += VY[i] * dt;
        if (kd === 1) {
          /* a star sheds sparks along its path, fewer as it burns out */
          var S = shellOf(i), lf = AGE[i] / LIFE[i];
          var spd = Math.sqrt(VX[i] * VX[i] + VY[i] * VY[i]) / RR[i];
          ACC[i] += EMIT[i] * dt * (1 - lf * lf * lf) * (0.7 + Math.min(2.2, spd * 0.9));
          while (ACC[i] >= 1) {
            ACC[i] -= 1;
            var w = rnd();
            spark(PX[i] + (X[i] - PX[i]) * w, PY[i] + (Y[i] - PY[i]) * w, VX[i] * 0.12 + gauss() * 0.02 * RR[i], VY[i] * 0.12 + gauss() * 0.02 * RR[i], S.spark[0] + (S.spark[1] - S.spark[0]) * rnd(), S.sheat * (1.05 - 0.4 * lf), phone ? 1.2 : 1.45, S.sdrag, S.sgrav * RR[i]);
          }
        } else if (kd === 4 && (FLAG[i] & 4) && !(FLAG[i] & 8) && AGE[i] > RR[i] * LIFE[i]) {
          /* an anar's spark that forks into a few short bright ones */
          FLAG[i] |= 8;
          for (k = 0; k < 3; k++) {
            var fa = rnd() * 6.283, fs = (0.12 + 0.2 * rnd()) * R0;
            var fj = spark(X[i], Y[i], VX[i] * 0.3 + Math.cos(fa) * fs, VY[i] * 0.3 + Math.sin(fa) * fs, 0.1 + 0.1 * rnd(), 1, phone ? 1.1 : 1.3, 3, 0.2 * R0, 4);
            if (fj >= 0) FLAG[fj] |= 1;
          }
        }
      }
      for (i = flashes.length - 1; i >= 0; i--) { flashes[i].age += dt; if (flashes[i].age > 0.3) flashes.splice(i, 1); }
    };

    /* drawing: sparks as small squares of light added to what is there, sorted by colour so each colour is set once */
    var BK = [], BKn = [];
    for (i = 0; i < 24; i++) { BK.push(new Int32Array(MAX)); BKn.push(0); }
    var AL = new Float32Array(MAX);
    var archPath = function () {
      var x = A.x, y = A.y, w = A.w, h = A.h, rx = w / 2, ry = 0.24 * h, rb = 12;
      ctx.beginPath();
      ctx.moveTo(x, y + ry);
      ctx.ellipse(x + rx, y + ry, rx, ry, 0, Math.PI, 2 * Math.PI);
      ctx.lineTo(x + w, y + h - rb);
      ctx.quadraticCurveTo(x + w, y + h, x + w - rb, y + h);
      ctx.lineTo(x + rb, y + h);
      ctx.quadraticCurveTo(x, y + h, x, y + h - rb);
      ctx.closePath();
    };
    var draw = function () {
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      ctx.globalCompositeOperation = 'source-over';
      ctx.globalAlpha = 1;
      ctx.clearRect(0, 0, W, H);
      ctx.globalCompositeOperation = 'lighter';
      for (var b = 0; b < 24; b++) BKn[b] = 0;
      var i, a, lv, lf;
      for (i = 0; i < n; i++) {
        var kd = KIND[i];
        if (kd === 1 || kd === 2) continue;
        if (kd === 3 && AGE[i] < 0) continue;
        lf = AGE[i] / LIFE[i];
        if (kd === 3) { a = 1; lv = 11; }
        else {
          var heat = HEAT[i] * (1 - (kd === 4 ? 0.45 : 0.62) * lf);
          lv = Math.max(0, Math.min(11, Math.round(heat * 11)));
          a = Math.pow(1 - lf, 1.3) * (0.42 + 0.58 * rnd());
        }
        AL[i] = a;
        var bk = lv + ((FLAG[i] & 1) ? 12 : 0);
        BK[bk][BKn[bk]++] = i;
      }
      var paint = function (from, to) {
        for (var b2 = from; b2 < to; b2++) {
          var cnt = BKn[b2];
          if (!cnt) continue;
          ctx.fillStyle = PAL[b2 % 12];
          var list = BK[b2];
          for (var m2 = 0; m2 < cnt; m2++) {
            var j = list[m2], s = SZ[j];
            ctx.globalAlpha = AL[j];
            ctx.fillRect(X[j] - s / 2, Y[j] - s / 2, s, s);
          }
        }
      };
      paint(0, 12);
      var inArch = fountains.length;
      for (b = 12; b < 24 && !inArch; b++) inArch = BKn[b];
      if (inArch) {
        ctx.save();
        archPath();
        ctx.clip();
        paint(12, 24);
        /* the anars' mouths: a hot white core in a little warm light */
        fountains.forEach(function (fo) {
          if (!fo.env) return;
          var fl = fo.env * (0.7 + 0.3 * rnd());
          ctx.globalAlpha = 0.16 * fl;
          ctx.drawImage(SPR[8], fo.x - 0.09 * A.w, fo.y - 0.09 * A.w, 0.18 * A.w, 0.18 * A.w);
          ctx.globalAlpha = 0.95 * fl;
          ctx.drawImage(SPR[11], fo.x - 7, fo.y - 7, 14, 14);
        });
        ctx.restore();
      }
      /* the stars and the rockets' heads, as soft lights */
      for (i = 0; i < n; i++) {
        if (KIND[i] !== 1) continue;
        lf = AGE[i] / LIFE[i];
        var hot = 0.62 + 0.38 * Math.exp(-AGE[i] / 0.12) - 0.3 * lf * lf;
        lv = Math.max(0, Math.min(11, Math.round(hot * 11)));
        a = Math.pow(Math.max(0, 1.15 - lf), 1.4) * (0.75 + 0.25 * rnd());
        var rr = (phone ? 4.2 : 5.2);
        ctx.globalAlpha = Math.min(1, a);
        ctx.drawImage(SPR[lv], X[i] - rr, Y[i] - rr, rr * 2, rr * 2);
      }
      rockets.forEach(function (r) {
        if (r.x === undefined) return;
        ctx.globalAlpha = 0.8 + 0.2 * rnd();
        var rh = phone ? 3.5 : 5;
        ctx.drawImage(SPR[10], r.x - rh, r.y - rh, rh * 2, rh * 2);
      });
      /* the moment of each burst: a short soft flash */
      flashes.forEach(function (f) {
        var k = 1 - f.age / 0.3;
        ctx.globalAlpha = 0.2 * k * k;
        ctx.drawImage(SPR[9], f.x - f.r, f.y - f.r, f.r * 2, f.r * 2);
      });
      ctx.globalAlpha = 1;
      ctx.globalCompositeOperation = 'source-over';
    };
    var over = function (t) { return t > 5 && !plan.length && !rockets.length && !fountains.length && n === 0; };
    return {
      step: step, draw: draw, over: over, size: function () { size(); },
      slow: function () { q = Math.max(0.45, q * 0.8); },
      remove: function () { if (cv.parentNode) cv.parentNode.removeChild(cv); }
    };
  };

  /* ---------------- the order of things ---------------- */
  var LIGHTS = 4.5;    /* seconds after the curtain begins to move, the store's lights come up (the last shell falling) */
  var gl = velvet();
  var fx = null, start = null, last = 0, lit = false, slowFrames = 0;
  if (gl) {
    gl.draw();
    cur.classList.add('is-gl');
    window.setTimeout(function () { cur.classList.add('is-gl-on'); }, 400);
  }
  var inView = function () { var r = arch.getBoundingClientRect(); return r.bottom > 0 && r.top < window.innerHeight; };
  /* the curtain out of view: taken away, nothing left of it in the arch */
  var gone = function () {
    if (cur.classList.contains('is-gone')) return;
    cur.classList.add('is-gone');
    if (gl) { gl.release(); gl = null; }
  };
  var finish = function () {
    if (fx) { fx.remove(); fx = null; }
    gone();
    if (!lit) { lit = true; head.classList.add('is-lit'); }
  };
  var tick = function (now) {
    var dt = last ? Math.min(0.05, (now - last) / 1000) : 1 / 60;
    if (last && now - last > 45) { if (++slowFrames > 8 && fx) { fx.slow(); slowFrames = 0; } } else slowFrames = Math.max(0, slowFrames - 1);
    last = now;
    var t = (now - start) / 1000;
    if (t >= 0) {
      if (!C.settled) stepCurtain(t, dt);
      if (C.gone) gone();
      if (fx) fx.step(t, dt);
      if (!lit && t > LIGHTS) { lit = true; head.classList.add('is-lit'); }
    }
    if (gl) gl.draw();
    if (fx) fx.draw();
    if (C.settled && (!fx || fx.over(t)) && t > LIGHTS) { finish(); return; }
    window.requestAnimationFrame(tick);
  };
  var begin = function () {
    if (start !== null) return;
    start = Math.max(performance.now() + 300, 900);
    if (!inView()) {
      /* opened further down the page: the store is shown open, with nothing to watch */
      openAtOnce();
      cur.classList.add('is-open');
      if (gl) gl.draw();
      finish();
      return;
    }
    if (!gl) window.setTimeout(function () { cur.classList.add('is-open'); }, Math.max(0, start - performance.now()));
    fx = crackers();
    window.requestAnimationFrame(tick);
  };
  if (!photo || (photo.complete && photo.naturalWidth)) begin();
  else {
    photo.addEventListener('load', begin, { once: true });
    photo.addEventListener('error', begin, { once: true });
    window.setTimeout(begin, 4000);
  }
  var pending = false;
  window.addEventListener('resize', function () {
    if (pending) return;
    pending = true;
    window.requestAnimationFrame(function () {
      pending = false;
      if (gl) { gl.size(); gl.draw(); }
      if (fx) fx.size();
    });
  });
})();
